module.exports = __webpack_public_path__ + "static/media/chat-icon.0bf3a530.png";